import { axiosInstance } from '../../network/apis';
const handlerEnabled = false;

// Replace endpoint and change api name
const getSliderImages = async () => {
    return await axiosInstance.get(`/api/v1/banners/getSliderImages`, {
        handlerEnabled
    });
};

export default {
    getSliderImages
};
